import { GraphValidationResultDto } from "@store/services/documentService"
import { atom } from "jotai"

export const presamplingValidationAtom = atom<GraphValidationResultDto>()

if (process.env.NODE_ENV !== "production") {
  presamplingValidationAtom.debugLabel = "presamplingValidationAtom"
}
